import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

export class ForceAction extends Performer<
  {
    payload: {
      chatId: string
      forcePrompt: string
    }
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/onboarding'
}

export default new ForceAction().perform
